export default __webpack_public_path__ + "static/media/Arrow 2 Down.4c4bd213.svg";